export const REPORT_CODE_OPTIONS = [
  { value: 'STR', text: 'STR' },
  { value: 'AIF', text: 'Additional Information File' },
  { value: 'DDR', text: 'DDR' },
  { value: 'IRD', text: '(IRD) - Incoming Request Domestic' },
  {
    value: 'IRI',
    text: '(IRI) - Incoming Request International Miscellaneous Intelligence Received',
  },
  { value: 'MSINT', text: 'Miscellaneous Intelligence Received' },
  { value: 'ORD', text: '(ORD) - Outgoing Request Domestic' },
  {
    value: 'ORI',
    text: '(ORI) - Outgoing Request International Politically Exposed Person',
  },
  { value: 'PEPR', text: 'Politically Exposed Person' },
  { value: 'PEPTR', text: 'Politically Exposed Person Transaction Report' },
  { value: 'SAR', text: 'Suspicious Activity Report' },
  { value: 'TFR', text: 'Terrorism Financing Report' },
  { value: 'TFTR', text: 'Terrorism Financing Transaction Report' },
  { value: 'TRN', text: 'Transaction Report (Art 28)' },
  { value: 'XBD', text: 'Automated Cross Border Disseminations' },
];
